<template functional>
    <img
        v-if="props.drawing"
        :class="data.class"
        style="background-size: cover; background-repeat: no-repeat; max-height: 240px;"
        :style="{'background-image': props.image ? `url(${props.image})` : undefined}"
        :src="props.drawing"
    />
    <img v-else
         :class="data.class"
         :src="props.image"
         style="max-height: 240px;"
    />
</template>

<script>
    export default {
        props: {
            image: {
                type: String,
                default: null,
            },
            drawing: {
                type: String,
                default: null,
            },
        },
    };
</script>
